import { __assign, __rest } from "tslib";
import React from 'react';
import mergeRefs from 'react-merge-refs';
import { getBaseProps } from '../../base-component';
import { fireCancelableEvent, fireNonCancelableEvent } from '../../events';
import { useFormFieldContext } from '../../context/form-field-context';
import InternalInput from '../../../input/internal';
import useMask from './use-mask';
import MaskFormat from './utils/mask-format';
var MaskedInput = React.forwardRef(function (_a, ref) {
    var value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange, onKeyDown = _a.onKeyDown, mask = _a.mask, _b = _a.autofix, autofix = _b === void 0 ? false : _b, _c = _a.disableAutocompleteOnBlur, disableAutocompleteOnBlur = _c === void 0 ? false : _c, rest = __rest(_a, ["value", "onBlur", "onChange", "onKeyDown", "mask", "autofix", "disableAutocompleteOnBlur"]);
    var baseProps = getBaseProps(rest);
    var formFieldContext = useFormFieldContext(rest);
    var inputRef = React.useRef(null);
    var _d = useMask({
        format: new MaskFormat(mask),
        value: value,
        inputRef: inputRef,
        autofix: autofix,
        disableAutocompleteOnBlur: disableAutocompleteOnBlur,
        onChange: function (value) { return !rest.readOnly && fireNonCancelableEvent(onChange, { value: value }); },
        onKeyDown: function (event) {
            return !rest.readOnly && onKeyDown && fireCancelableEvent(onKeyDown, event.detail, event);
        },
        onBlur: function () { return fireNonCancelableEvent(onBlur); }
    }), onPaste = _d.onPaste, maskProps = __rest(_d, ["onPaste"]);
    var inputProps = __assign(__assign(__assign(__assign({}, rest), baseProps), formFieldContext), maskProps);
    return (React.createElement(InternalInput, __assign({}, inputProps, { ref: mergeRefs([ref, inputRef]), __nativeAttributes: {
            onPaste: onPaste
        } })));
});
export { useMask };
export default MaskedInput;
//# sourceMappingURL=index.js.map